import { render, staticRenderFns } from "./CourseSelectDialog.vue?vue&type=template&id=4eea729c&scoped=true"
import script from "./CourseSelectDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseSelectDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CourseSelectDialog.vue?vue&type=style&index=0&id=4eea729c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eea729c",
  null
  
)

export default component.exports